// NewsDetailPage.js
import React from "react";
import { Box } from "@mui/material";
import Container from "@mui/material/Container";
import SliderImage from "./SliderImage";
import {useParams } from "react-router-dom";

const NewsDetail = () => {
  const { index } = useParams();

  let newsDetail;
  if (index === "0") {
    newsDetail = (
      <Box>
        <Box
          sx={{
            fontSize: "18px",
            borderBottom: "2px solid #ccc",
            textAlign: "center",
            padding: "15px 0",
          }}
        >
          Petrol price rise warning after Opec oil output cut
        </Box>
        <Box sx={{ pt: { xs: 4, sm: 4 } }}>
          <strong>
            Some of the world's top oil-producing countries have agreed to cut
            the amount they export in a decision expected to raise petrol prices
            around the world.
          </strong>
        </Box>
        <Box sx={{pb: { xs: 10, sm: 10 } }} >
        <p >
          Members of Opec+ - a group that includes Saudi Arabia and Russia -
          said they would slash production by two million barrels per day.{" "}
          <br />
          The group said it wanted to stabilise prices, which have fallen in
          recent months as the world economy slows. <br />
          But the decision raised fears that prices for motorists will climb.{" "}
          <br />
          Expectations that countries were planning to pump less had already
          pushed oil prices higher this week. The price of a barrel of Brent
          crude jumped another almost 2% to more than $93 (£82) a barrel on
          Wednesday.
          <br /> A spokesman for the RAC motoring group said the reduction
          announced on Wednesday would "inevitably" lead to higher oil prices,
          forcing up the wholesale cost of fuel. <br />
          "The question is when, and to what extent, retailers choose to pass
          these increased costs on at their forecourts," spokesman Simon
          Williams said. <br />
          The cut announced by the Organization of the Petroleum Exporting
          Countries (Opec) and allies marks the biggest reduction by the group
          since the height of the pandemic in 2020. <br />
          It comes despite pleas from the US and others to pump more, after oil
          prices spiked this spring when the war in Ukraine disrupted supplies.
        </p>
        <p>
          <a href="https://www.bbc.com/news/business-61188579">
            Why are the world's big oil producers cutting supplies?
          </a>
        </p>
        <p>
          In a statement, the White House said US President Joe Biden was
          "disappointed by the short-sighted decision".
          <br />
          The US pledged to continue to release oil from national stockpiles "as
          appropriate" and look at other ways to try to rein in prices at the
          pump, which are a key issue for American voters in midterm elections
          scheduled for November.
          <br /> The move is also likely to disrupt US-led efforts to set a
          price cap for oil from Russia, a plan the US had suggested as a way to
          limit money flowing into the country and being put towards military
          use. <br />
          Opec members defended their decision as a response to significant
          "uncertainty" about future demand for oil, amid fears that the global
          economy is heading towards a recession. <br />
          "The decision is technical, not political," United Arab Emirates
          Energy Minister Suhail al-Mazroui told reporters as Opec+ members
          gathered in Vienna to discuss the plans.
        </p>
        </Box>
      </Box>
    );
  } else if (index === "1") {
    newsDetail = (
      <Box>
        <Box
          sx={{
            fontSize: "18px",
            borderBottom: "2px solid #ccc",
            textAlign: "center",
            padding: "15px 0",
          }}
        >
          China keeps oil prices unchanged, stability expected in Q4 despite
          global volati
        </Box>
        <Box sx={{ pt: { xs: 4, sm: 4 }, pb: { xs: 10, sm: 10 } }}>
          
            China's top economic planner announced on Monday that the retail
            prices of gasoline and diesel will not be changed in October despite
            a week of rising global oil prices and tight supplies.
            <div style={{ paddingTop: "30px" }}>
              This is the first time the National Development and Reform
              Commission (NDRC) suspended oil price adjustment in 2022.
            </div>
            <div style={{ paddingTop: "30px" }}>
              So far this year, the retail prices of refined oil products have
              been adjusted 19 times, with 11 hikes and seven cuts. Under the
              country's pricing mechanism, the NDRC usually adjusts prices in
              accordance to international crude oil prices.
            </div>
            <div style={{ paddingTop: "30px" }}>
              The price of gasoline is up by 1,305 yuan ($182.6) per ton so far
              in 2022, with the diesel price up by 1,255 yuan per ton, according
              to the NDRC.
            </div>
            <div style={{ paddingTop: "30px" }}>
              Although international oil prices this winter will largely reflect
              developments in the Russia-Ukraine conflict and the global
              economy, China's oil price will likely remain stable in the fourth
              quarter, industry insiders said.
            </div>
            <div style={{ paddingTop: "30px" }}>
              This is due to China's oil pricing mechanism, they noted. Domestic
              refined oil prices are adjusted every 10 working days according to
              changes in the international market.
            </div>
            <div style={{ paddingTop: "30px" }}>
              The average oil price of the first 10 working days before Monday,
              compared with the first 10 working days before September 21, the
              starting day of the last price adjustment session, was about 30
              yuan per ton, which did not hit the price changing threshold of 50
              yuan per ton, according to insiders.
            </div>
            <div style={{ paddingTop: "30px" }}>
              The Organization of the Petroleum Exporting Countries (OPEC) and
              its non-OPEC allies, namely OPEC+, decided last week to  <a href="https://www.globaltimes.cn/page/202210/1276594.shtml">cut
              production by 2 million barrels</a> per day (about 273,970 tons).
            </div>
            <div style={{ paddingTop: "30px" }}>
              Following the decision, international oil prices soared for five
              consecutive trading days.
            </div>
            <div style={{ paddingTop: "30px" }}>
              On the New York Mercantile Exchange, the benchmark West Texas
              Intermediate crude rose 16.54 percent and the benchmark price on
              the Intercontinental Exchange Europe, Brent crude, rose 11.32
              percent, both posting their biggest weekly gains in seven months.
            </div>
            <div style={{ paddingTop: "30px" }}>
              Meanwhile, amid a global interest rate hike cycle, the economic
              downturn has inevitably reduced energy demand, which was the main
              reason for the OPEC+ production cut this time, Feng Mohan, a
              research fellow of macroeconomy at Beijing Fost Economic
              Consulting, told the Global Times on Monday.
            </div>
            <div style={{ paddingTop: "30px" }}>
              "The production cuts of OPEC+ will boost oil prices in the short
              term. But oil prices are poised for a downward trend in 2023, as
              the actual production cut of OPEC+ is expected to be less than its
              agreement," said Feng.
            </div>
            <div style={{ paddingTop: "30px" }}>
              Qu Xinrong, a research fellow at the Cheung Kong Graduate School
              of Business, said that although the production cut will support
              crude oil prices, there is little chance that international oil
              prices will rise above $100 per barrel.
            </div>
            <div style={{ paddingTop: "30px" }}>
              "Domestic gasoline and diesel prices are relatively high, which
              pressures the downstream of industry chains. But the room for
              price hikes is limited," Qu told the Global Times on Monday.
            </div>
            <div style={{ paddingTop: "30px" }}>
              Feng said that as the US midterm elections are approaching, there
              will be occasional news to restrain oil prices, and the room for
              significant hikes is limited.
            </div>
            <div style={{ paddingTop: "30px" }}>
              The US Department of Energy on Friday awarded 10.15 million
              barrels of Strategic Petroleum Reserve crude for November
              delivery, on top of the 155 million barrels that have already been
              delivered.
            </div>
            <div style={{ paddingTop: "30px" }}>
              The escalating conflict between Russia and Ukraine has also raised
              the prospect of higher global oil prices amid tight supplies and
              geopolitical fallout, analysts said.
            </div>
            <div style={{ paddingTop: "30px" }}>
              Still, gasoline and diesel prices in China are expected to remain
              stable thanks to the country's efforts to ensure stable supplies
              and prices, analysts noted.
            </div>
            <div style={{ paddingTop: "30px" }}>
              <strong>By Chi Jingyi</strong>
            </div>
         
        </Box>
      </Box>
    );
  } else {
    newsDetail = "No news detail found for this inde";
  }

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        padding: "0 20px", // Adjust as needed
      }}
    >
    <SliderImage/>
      {/* <h2>News Detail</h2> */}
      {typeof newsDetail === "string" ? (
        <p>{newsDetail}</p>
      ) : (
        <div>{newsDetail}</div>
      )}
    </Container>
  );
};

export default NewsDetail;
